import * as types from "~/store/payment/paymentType";

export const stopGetStatusTransaction = () => ({
  type: types.STOP_GET_STATUS_TRANSACTION
});

export const getStatusTransaction = status => ({
  type: types.GET_STATUS_TRANSACTION,
  status
});

export const getMedicalBillByHospitalId = data => ({
  type: types.GET_MEDICAL_BILL_BY_HOSPITALID_REQUEST,
  data
});

export const requestInsuranceCard = paymentID => {
  return {
    type: types.REQUEST_HEALTH_INSURANCE_CARD,
    paymentID
  };
};

export const selectedToShowModal = info => {
  return {
    type: types.SELECTED_HEALTH_INSURANCE_TO_SHOWM_MODAL,
    info
  };
};

export const selectedToShowResendSMSModal = info => {
  return {
    type: types.SELECTED_HEALTH_INSURANCE_TO_SHOWM_RESEND_SMS_MODAL,
    info
  };
};

export const toggleModalMedicalBill = () => {
  return {
    type: types.TOGGLE_MODAL_HEALTH_INSURANCE_CARD
  };
};

export const toggleResendSMSModal = info => {
  return {
    type: types.TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD
  };
};

export const hideAlertSMSOK = () => {
  return {
    type: types.HIDE_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD
  };
};

export const getAllPaymentMethod = (price = null) => {
  return {
    type: types.UMC_GET_ALL_PAYMENT_METHODS,
    payload: price
  };
};
export const getAllFeePaymentMethod = () => {
  return {
    type: types.GET_ALL_PAYMENT_METHOD_FEE
  };
};

export const togglePaymentMethod = () => {
  return {
    type: types.TOGGLE_MODAL_PAYMENT_METHOD
  };
};

export const hideModalPaymentMethod = () => {
  return {
    type: types.HIDE_MODAL_PAYMENT_METHOD
  };
};

export const selectedPaymentMethod = (method, methodId) => {
  return {
    type: types.SELECTED_PAYMENT_METHOD,
    method,
    methodId
  };
};

export const resetPaymentMethod = () => {
  return {
    type: types.RESET_ALL_PROPS_PAYMENT_METHOD
  };
};

export const checkRequirePayment = () => {
  return {
    type: types.CHECK_REQUIRE_PAYMENT
  };
};

export const setPriceOfSvAddOn = (price = 0) => {
  return {
    type: types.SET_PRICE_OF_SERVICE_ADD_ON,
    price
  };
};

export const resetPrice = () => {
  return {
    type: types.RESET_PRICE_PAYMENT
  };
};
